import { useRendererContext } from './renderer-context';
export var useFeatureFlags = function useFeatureFlags() {
  var _useRendererContext;
  return (_useRendererContext = useRendererContext()) === null || _useRendererContext === void 0 ? void 0 : _useRendererContext.featureFlags;
};